import dayjs, { Dayjs } from 'dayjs';

/** Parse an ISO/date string into a valid Dayjs, or null. */
export const toDayjs = (value?: string | null): Dayjs | null => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

/** Serialize a Dayjs to an ISO string, or '' when null/invalid. */
export const toIso = (value: Dayjs | null): string => (value && value.isValid() ? value.toISOString() : '');
